// @flow
import Button, { type ButtonProps as ButtonPropsBase } from '@shared/Button/components/Button';
import * as buttonConstants from '@shared/Button/constants';

export type ButtonProps = ButtonPropsBase;
export { buttonConstants };
export default Button;
